import React from 'react';
import Hero from '../components/Hero';
import { Helmet } from 'react-helmet';
import Services from '../components/Services';
import AboutUs from './../components/AboutUs';
import WhyChooseUs from './../components/WhyChooseUs';
import FeaturesSection from './../components/FeaturesSection';
import OurWorks from '../components/OurWorks';
import ClientsSection from './../components/ClientsSection';
import PartnershipSection from './../components/PartnershipSection';
import banner from '../assets/driveinvideobanner.mp4'
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/product');
  };
  return (
    <div>
      <Helmet>
        <link rel="canonical" href="https://driveincarspa.com/" />
        <title>Best Automatic Car Wash Machine Near Me</title>
        <meta name="description" content="Find automatic car wash machines near you for quick and efficient vehicle cleaning. Get professional car wash services with modern technology." />
        <meta name="keywords" content="automatic car wash machine  near me, Professional Car Detailing Services, Premium Car Spa in Bangalore, 
Complete Car Cleaning Services, Car Wash Machine, Best Car Spa Near Me" />
        <meta name="author" content="DriveIn Team" />
      </Helmet>
      <Hero
      title={<><span className="highlight">Premium Touchless</span><br />Automatic Car Wash Machine Near You</>}
        subtitle="Looking for an automatic car wash machine near me? Experience flawless cleaning, minimal contact, and ultimate gloss—powered by German-engineered precision and innovation."
        bgVideo={banner}
        onButtonClick={handleServicesClick}
      />
      <Services />
      <AboutUs/>
      <WhyChooseUs/>
      <FeaturesSection/>
      <OurWorks/>
      <ClientsSection/>
      <PartnershipSection/>
    </div>
  );
};

export default Home;
